import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardWrapperModule } from '../card-wrapper/card-wrapper.module';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'notification',
  templateUrl: './ui-notification.component.html',
  styleUrls: ['./ui-notification.component.scss'],
  imports: [CommonModule, CardWrapperModule, IconComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiNotificationComponent {

  /**
   * Visual changes of form
   *
   * @type {('' | 'alarm' | 'attention')}
   * @memberof UiNotificationComponent
   */
  @Input() type: '' | 'alarm' | 'attention';
  @Input() textAlign: '' | 'start' | 'end';
  @Input() noMargin = false;

  /**
   * Structural changes of element
   *
   * @type {'attention'}
   * @memberof UiNotificationComponent
   */
  @Input() theme: 'attention';
}
